var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 1.5C14.7857 1.5 17.4566 2.60633 19.4259 4.5756C21.3952 6.54487 22.5015 9.21578 22.5015 12.0007C22.5015 14.7857 21.3952 17.4566 19.4259 19.4259C17.4566 21.3952 14.7857 22.5015 12.0008 22.5015C9.21578 22.5015 6.54487 21.3952 4.5756 19.4259C2.60633 17.4566 1.5 14.7857 1.5 12.0007C1.5 9.21578 2.60633 6.54487 4.5756 4.5756C6.54487 2.60633 9.21578 1.5 12.0008 1.5ZM13.5758 7.947C14.3558 7.947 14.9887 7.4055 14.9887 6.603C14.9887 5.8005 14.3542 5.259 13.5758 5.259C12.7957 5.259 12.1657 5.8005 12.1657 6.603C12.1657 7.4055 12.7957 7.947 13.5758 7.947ZM13.8502 16.3875C13.8502 16.227 13.9057 15.81 13.8742 15.573L12.6413 16.992C12.3863 17.2605 12.0667 17.4465 11.9167 17.397C11.8487 17.372 11.7918 17.3234 11.7564 17.2602C11.7209 17.197 11.7091 17.1231 11.7233 17.052L13.7782 10.56C13.9462 9.7365 13.4843 8.985 12.5048 8.889C11.4713 8.889 9.95025 9.9375 9.02475 11.268C9.02475 11.427 8.99475 11.823 9.02625 12.06L10.2577 10.6395C10.5127 10.374 10.8098 10.1865 10.9598 10.2375C11.0337 10.264 11.0942 10.3185 11.1284 10.3891C11.1626 10.4598 11.1678 10.5411 11.1427 10.6155L9.10575 17.076C8.87025 17.832 9.31575 18.573 10.3958 18.741C11.9858 18.741 12.9248 17.718 13.8517 16.3875H13.8502Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6ea21da67013d100593c2be2b5cd8b31.svg";
export { ForwardRef as ReactComponent };